import React from 'react'
import { Container, Box } from '@mui/material'
import { Navigate, useNavigate } from 'react-router-dom'
import { LoginForm } from '../components/auth/LoginForm'
import { useAuth } from '../contexts/AuthContext'

export const AuthPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()

  // 既に認証済みの場合はダッシュボードにリダイレクト
  if (!isLoading && isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  const handleSwitchToRegister = () => {
    navigate('/register')
  }

  return (
    <Container component="main" maxWidth="sm" sx={{ px: { xs: 2, sm: 3 } }}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: { xs: 2, sm: 4 },
        }}
      >
        <Box sx={{ width: '100%' }}>
          <LoginForm onSwitchToRegister={handleSwitchToRegister} />
        </Box>
      </Box>
    </Container>
  )
}
